// =============================================================================
// importRequests.js
//
// Chamadas HTTP à API do Bulk Import (ActivityImportController).
// Mesmas regras que trackerRequests.js: 1 função = 1 endpoint, devolve a
// Promise do Axios, não toca em state/dispatch.
// =============================================================================

import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest.js';

const BASE = `${config.API_URL}ActivityImport`;

// ── Runtime ───────────────────────────────────────────────────────────────────

// { canImport: bool } — decide se o botão "Bulk Import" aparece no toolbar.
export const apiCanImport = () =>
	AxiosRequest({ method: 'GET', url: `${BASE}/CanImport` });

// [{ id, side, name }] — Templates activos, para o picker de Side no upload.
export const apiGetAvailableTemplates = () =>
	AxiosRequest({ method: 'GET', url: `${BASE}/AvailableTemplates` });

// { teamId, ownerId } — Team/Owner por omissão para quem está a fazer o
// upload (pode vir null em qualquer um dos dois). Usado para pré-preencher
// o ecrã de Preview.
export const apiGetUploaderDefaults = () =>
	AxiosRequest({ method: 'GET', url: `${BASE}/UploaderDefaults` });

// Preview: não grava nada. Devolve title/vendor/technology/comments propostos +
// os sites resolvidos (com Selected pré-marcado) + JV_IDs sem correspondência.
export const apiPreviewImport = (templateId, file) => {
	const formData = new FormData();
	formData.append('file', file);
	return AxiosRequest({
		method: 'POST',
		url: `${BASE}/Preview`,
		params: { templateId },
		data: formData,
		hasLoading: true,
	});
};

// Commit: cria 1 TrackerEntry (IsRestricted = true) com os sites confirmados.
// data = { templateId, fileName, title, vendor, technology, comments, featureId,
//          startDate, endDate, rowCount, matches, unmatchedJvIds }
export const apiCommitImport = (data) =>
	AxiosRequest({ method: 'POST', url: `${BASE}/Commit`, data, hasLoading: true });


// ── Settings: Templates ──────────────────────────────────────────────────────

export const apiGetImportTemplates = () =>
	AxiosRequest({ method: 'GET', url: `${BASE}/Templates` });

// data = { id, side, name, expectedHeaders, defaultFeatureId, isActive, sortOrder, mappings, aliases }
export const apiSaveImportTemplate = (data) =>
	AxiosRequest({ method: 'POST', url: `${BASE}/Templates`, data });

export const apiDeleteImportTemplate = (id) =>
	AxiosRequest({ method: 'DELETE', url: `${BASE}/Templates/${id}` });

// Lê só os cabeçalhos de um ficheiro de amostra — usado ao configurar um Template novo.
export const apiReadImportHeaders = (file) => {
	const formData = new FormData();
	formData.append('file', file);
	return AxiosRequest({
		method: 'POST',
		url: `${BASE}/Templates/ReadHeaders`,
		data: formData,
		hasLoading: true,
	});
};


// ── Settings: Authorized Users ───────────────────────────────────────────────

export const apiGetImportAuthorizedUsers = () =>
	AxiosRequest({ method: 'GET', url: `${BASE}/AuthorizedUsers` });

export const apiSaveImportAuthorizedUser = (data) =>
	AxiosRequest({ method: 'POST', url: `${BASE}/AuthorizedUsers`, data });

export const apiDeleteImportAuthorizedUser = (id) =>
	AxiosRequest({ method: 'DELETE', url: `${BASE}/AuthorizedUsers/${id}` });
